module.exports = __webpack_public_path__ + "media/images/social-icons/email-a309cbfebec2b90976ceec2bf8e2cf8e.svg";